module.exports = __webpack_public_path__ + "img/success_icon.5eb4f042.svg";